import React from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const MAX_MB = 200;
const ACCEPT = 'video/mp4,video/quicktime,video/webm,video/x-m4v,.mp4,.mov,.webm,.m4v,.avi,.mkv';

// Bouton d'ajout de vidéo sur une activité.
//   - Voyageur : fournir bookingId (participation vérifiée côté backend).
//   - Guide propriétaire : sans bookingId (vidéo promo).
export default function VideoUpload({ activityId, bookingId, onUploaded, label }) {
  const inputRef = React.useRef(null);
  const [busy, setBusy] = React.useState(false);
  const [msg, setMsg] = React.useState(null); // { type: 'ok' | 'err', text }

  function pick() {
    if (inputRef.current) inputRef.current.click();
  }

  function onFile(e) {
    const file = e.target.files && e.target.files[0];
    e.target.value = ''; // autorise de re-choisir le même fichier ensuite
    if (!file) return;
    if (file.size > MAX_MB * 1024 * 1024) {
      setMsg({ type: 'err', text: `Vidéo trop lourde (max ${MAX_MB} Mo).` });
      return;
    }
    const fd = new FormData();
    fd.append('file', file);
    let url = `${API_URL}/api/activities/${activityId}/videos`;
    if (bookingId) url += `?booking_id=${encodeURIComponent(bookingId)}`;

    setBusy(true);
    setMsg(null);
    axios
      .post(url, fd, { withCredentials: true })
      .then((r) => {
        setMsg({ type: 'ok', text: (r.data && r.data.message) || 'Vidéo envoyée ! Visible après validation.' });
        if (onUploaded) onUploaded(r.data);
      })
      .catch((err) => {
        const d = err.response && err.response.data && err.response.data.detail;
        setMsg({ type: 'err', text: d || "Échec de l'envoi, réessayez." });
      })
      .finally(() => setBusy(false));
  }

  return (
    <div className="mt-3" data-testid="video-upload">
      <input ref={inputRef} type="file" accept={ACCEPT} onChange={onFile} className="hidden" />
      <button
        type="button"
        onClick={pick}
        disabled={busy}
        className="inline-flex items-center gap-2 rounded-full bg-[#f9004d] px-5 py-2.5 text-sm font-bold text-white transition hover:bg-[#d80043] disabled:opacity-60"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 5v14M5 12h14" />
        </svg>
        {busy ? 'Envoi…' : (label || 'Ajouter une vidéo')}
      </button>
      <p className="text-zinc-500 text-xs mt-1.5">
        Format court (max 60 s, 200 Mo). Validée par notre équipe avant publication.
      </p>
      {msg && (
        <p className={`text-xs mt-1.5 ${msg.type === 'ok' ? 'text-emerald-400' : 'text-red-400'}`}>{msg.text}</p>
      )}
    </div>
  );
}
